import React from 'react';
import PropTypes from 'prop-types';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import MarketingModal from './MarketingModal';
import { EN_US } from '../../utils/constants/LanguageRegionCode';
import * as styles from './styles/styles.module.scss';
import { getLocale } from '../../utils/language_support_util';
import LocalePropType from '../../proptypes/LocalePropType';

const {
  strings: { TAKE_YOUR_ALLTRAILS, TRY_THE_ALLTRAILS_APP, APP_INSTALL_ALT, GET_MORE_FROM }
} = StringConstantsMixin;

function Picture({ locale }) {
  // I think this is better than writing a bunch of import statements
  /* eslint-disable global-require, import/no-dynamic-require */
  const jpg = require(`./appinstall-${locale}.jpg`).default;
  const avif = require(`./appinstall-${locale}.avif`).default;
  const avif2x = require(`./appinstall-${locale}-2x.avif`).default;
  const avif3x = require(`./appinstall-${locale}-3x.avif`).default;
  /* eslint-enable global-require, import/no-dynamic-require */

  return (
    <picture>
      <source srcSet={avif} type="image/avif" />
      <source srcSet={`${avif2x} 2x`} type="image/avif" />
      <source srcSet={`${avif3x} 3x`} type="image/avif" />
      <img alt={APP_INSTALL_ALT} className={styles.img} src={jpg} />
    </picture>
  );
}

Picture.propTypes = {
  locale: LocalePropType.isRequired
};

function AppInstallModal({ branchKey, languageRegionCode, mobileBrowser }) {
  const locale = getLocale(languageRegionCode);

  return (
    <MarketingModal
      branchKey={branchKey}
      color="white"
      headerText={TAKE_YOUR_ALLTRAILS}
      instructionsText={languageRegionCode === EN_US ? TRY_THE_ALLTRAILS_APP : GET_MORE_FROM}
      languageRegionCode={languageRegionCode}
      mobileBrowser={mobileBrowser}
      picture={<Picture locale={locale} />}
    />
  );
}

AppInstallModal.propTypes = {
  branchKey: PropTypes.string.isRequired,
  languageRegionCode: PropTypes.string.isRequired,
  mobileBrowser: PropTypes.bool.isRequired
};

export default AppInstallModal;
